(() => {
  if (window.ssCartGiftDrawerReady) return;
  window.ssCartGiftDrawerReady = true;

  const giftProductTitles = ['Nike Socks', 'Random Key Chain'];
  const giftDiscountTitles = ['Sneak Spot Gifts', 'מתנות חינם'];
  const zeroPricePattern = /(?:₪\s*)?0(?:\.00)?(?:\s*₪)?/;

  const ensureGiftDrawerStyles = () => {
    if (document.getElementById('ss-cart-gift-drawer-styles')) return;

    const style = document.createElement('style');
    style.id = 'ss-cart-gift-drawer-styles';
    style.textContent = `
      cart-drawer .ss-cart-gift-item .cart-item__quantity,
      cart-drawer .ss-cart-gift-item .cart-item__details dl,
      cart-drawer .ss-cart-gift-item .ss-cart-gift-badge {
        display: none !important;
      }

      cart-drawer .ss-cart-gift-free-price {
        font-family: 'Heebo', Arial, sans-serif;
        font-weight: 800;
        color: #111;
      }
    `;
    document.head.appendChild(style);
  };

  const hasGiftDiscountTitle = (text) => giftDiscountTitles.some((title) => text.includes(title));
  const hasGiftProductTitle = (text) => giftProductTitles.some((title) => text.includes(title));

  const normalizeCartGiftLines = () => {
    ensureGiftDrawerStyles();

    document.querySelectorAll('cart-drawer .cart-item').forEach((row) => {
      const rowText = row.textContent || '';
      const isAutoGiftRow = hasGiftProductTitle(rowText) && (hasGiftDiscountTitle(rowText) || zeroPricePattern.test(rowText));

      row.querySelectorAll('.discounts__discount').forEach((discount) => {
        if (hasGiftDiscountTitle(discount.textContent || '')) discount.remove();
      });

      row.querySelectorAll('.discounts').forEach((discountList) => {
        if (!discountList.children.length) discountList.remove();
      });

      if (!isAutoGiftRow) return;

      row.classList.add('ss-cart-gift-item');
      row.querySelector('.cart-item__details dl')?.remove();
      row.querySelector('.ss-cart-gift-badge')?.remove();

      const quantityCell = row.querySelector('.cart-item__quantity');
      if (quantityCell) quantityCell.setAttribute('hidden', '');

      row.querySelectorAll('.cart-item__final-price, .price--end, .product-option').forEach((priceElement) => {
        if (priceElement.classList.contains('cart-item__old-price')) return;
        if (!zeroPricePattern.test(priceElement.textContent || '')) return;

        priceElement.textContent = 'חינם';
        priceElement.classList.add('ss-cart-gift-free-price');
      });
    });
  };

  window.ssNormalizeCartGiftLines = normalizeCartGiftLines;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', normalizeCartGiftLines, { once: true });
  } else {
    normalizeCartGiftLines();
  }

  new MutationObserver(normalizeCartGiftLines).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const activeSubmitButton = evt.submitter?.matches('[type="submit"]') ? evt.submitter : this.submitButton;
        const isQuickBuy = activeSubmitButton?.hasAttribute('data-ss-quick-buy');
        const activeSpinner = activeSubmitButton?.querySelector('.loading__spinner') || this.querySelector('.loading__spinner');

        if (activeSubmitButton?.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        activeSubmitButton.setAttribute('aria-disabled', true);
        activeSubmitButton.classList.add('loading');
        activeSpinner?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        const formData = new FormData(this.form);
        const productVariantId = formData.get('id');
        const shouldAddAutoGifts = this.dataset.ssAutoGifts === 'true';

        if (shouldAddAutoGifts && productVariantId) {
          const quantityInput = this.form.querySelector('[name="quantity"]');
          const quantity = Math.max(parseInt(quantityInput?.value || '1', 10) || 1, 1);
          const giftVariantIds = [
            this.dataset.ssGiftKeychainVariantId,
            this.dataset.ssGiftSocksVariantId,
          ].filter(Boolean);
          const payload = {
            items: [
              ...giftVariantIds.map((id) => ({
                id: Number(id),
                quantity,
                properties: {
                  _ss_free_gift: 'true',
                  _ss_gift_label: 'מתנה להזמנת נעל',
                },
              })),
              {
                id: Number(productVariantId),
                quantity,
              },
            ],
          };

          if (this.cart) {
            payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
            payload.sections_url = window.location.pathname;
            this.cart.setActiveElement(document.activeElement);
          }

          config.headers['Content-Type'] = 'application/json';
          config.body = JSON.stringify(payload);
        } else {
          delete config.headers['Content-Type'];

          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }

          config.body = formData;
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId,
                cartData: response,
            });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (isQuickBuy) {
              const cartIconBubble = document.getElementById('cart-icon-bubble');
              if (cartIconBubble && response.sections?.['cart-icon-bubble']) {
                cartIconBubble.innerHTML = new DOMParser()
                  .parseFromString(response.sections['cart-icon-bubble'], 'text/html')
                  .querySelector('.shopify-section')?.innerHTML || cartIconBubble.innerHTML;
              }

              await window.ssNormalizeCartGiftLines?.();
              await window.ssSyncCartGifts?.({ render: false });

              if (typeof window.ssOpenBundleCheckoutFlow === 'function') {
                await window.ssOpenBundleCheckoutFlow();
              } else {
                window.location.href = '/checkout';
              }
            } else if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                    window.ssNormalizeCartGiftLines?.();
                    window.ssSyncCartGifts?.({ render: true });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
              window.ssNormalizeCartGiftLines?.();
              window.ssSyncCartGifts?.({ render: true });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            activeSubmitButton?.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) activeSubmitButton?.removeAttribute('aria-disabled');
            activeSpinner?.classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
